module.exports = __webpack_public_path__ + "img/sun_on.eff17e21.svg";